import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FaGripVertical, FaTimes, FaEllipsisV } from 'react-icons/fa';

const CourseList = ({ courses, onRemove, isViewMode = false }) => {
  if (!courses.length) {
    return (
      <div className="flex flex-col items-center justify-center p-8 text-gray-500">
        <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-3">
          <FaEllipsisV className="w-5 h-5" />
        </div>
        <p>No courses added yet</p>
        <p className="text-sm">Click the + button below to add courses</p>
      </div>
    );
  }

  const CourseCard = ({ course, index }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: course._id, disabled: isViewMode });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      opacity: isDragging ? 0.5 : 1,
    };

    return (
      <div
        ref={setNodeRef}
        style={style}
        className="relative flex items-center group"
      >
        <div className={`flex-1 bg-white rounded-lg border border-gray-200 shadow-sm ${!isViewMode && 'hover:shadow-md transition-shadow'}`}>
          <div className="flex items-center p-4">
            {!isViewMode && (
              <div {...listeners} {...attributes} className="cursor-grab active:cursor-grabbing">
                <FaGripVertical className="w-4 h-4 text-[#1086a4] opacity-50 group-hover:opacity-100 transition-opacity" />
              </div>
            )}

            <div className="flex-1 min-w-0 px-3">
              <h3 className="text-sm font-medium text-[#054581]">
                {course.title}
              </h3>
              <p className="text-xs text-gray-500 mt-0.5">
                {(() => {
                  const lessonCount = course.lessonsCount ?? course.lessons?.length ?? 0;
                  const submissionFormCount = course.submissionFormsCount ?? course.submissionForms?.length ?? 0;
                  const parts = [];

                  if (lessonCount > 0) {
                    parts.push(`${lessonCount} ${lessonCount === 1 ? 'Lesson' : 'Lessons'}`);
                  }

                  if (submissionFormCount > 0) {
                    parts.push(`${submissionFormCount} ${submissionFormCount === 1 ? 'Mission' : 'Missions'}`);
                  }

                  return parts.length > 0 ? parts.join(' • ') : 'No content';
                })()}
              </p>
            </div>

            {!isViewMode && onRemove && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(course._id);
                }}
                className="p-1 text-gray-400 hover:text-red-500 rounded-full hover:bg-gray-100"
              >
                <FaTimes className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="relative pb-16">
      {/* Vertical timeline line in the middle */}
      <div className="absolute left-1/2 top-0 bottom-0 w-0.5 border-l-2 border-dashed border-[#1086a4]" />
      
      <div className="space-y-6">
        {courses.map((course, index) => (
          <CourseCard key={course._id} course={course} index={index} />
        ))}
      </div>
    </div>
  );
};

export default CourseList; 